import { http } from "./http";

/**
 * Módulo de operação (/api/admin/logs, /errors, /system).
 * O backend decide o escopo pelo usuário autenticado; o frontend só filtra.
 */

export interface LogEntry {
  id: string;
  scope: "builder" | "project";
  source: string;
  level: string;
  message: string;
  project_id?: string | null;
  project_name?: string | null;
  logged_at: string;
}

export interface LogMeta {
  levels: string[];
  builder_sources: string[];
  project_sources: string[];
}

export interface LogFilters {
  level?: string;
  source?: string;
  project?: string;
  from?: string;
  to?: string;
  search?: string;
  limit?: number;
}

export interface ErrorEventItem {
  id: string;
  fingerprint: string;
  source: string;
  level: string;
  type: string;
  message: string;
  project?: { uuid: string; name: string } | null;
  run_id?: string | null;
  first_seen_at: string | null;
  last_seen_at: string | null;
  occurrences: number;
  resolved: boolean;
  context?: Record<string, unknown> | null;
}

export type HealthStatus = "ok" | "warning" | "down";

export interface HealthComponent {
  key: string;
  label: string;
  status: HealthStatus;
  details: Record<string, unknown>;
}

export interface SystemHealth {
  status: HealthStatus;
  checked_at: string;
  components: HealthComponent[];
}

function query(filters: Record<string, unknown>): string {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  const search = params.toString();
  return search ? `?${search}` : "";
}

export const observabilityService = {
  logs: (filters: LogFilters = {}) =>
    http.getWithMeta<LogEntry[], LogMeta>(`/admin/logs${query({ ...filters })}`),

  errors: (filters: Record<string, unknown> = {}) =>
    http.get<ErrorEventItem[]>(`/admin/errors${query(filters)}`),

  toggleError: (id: string) => http.post<{ id: string; resolved: boolean }>(`/admin/errors/${id}/toggle`),

  system: () => http.get<SystemHealth>("/admin/system"),
};
